/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useState, useEffect } from 'react';

const useDebounce = (value, delay, callback = () => {}) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(
        () => {
            // Set debouncedValue to value (passed in) after the specified delay
            const handler = setTimeout(() => {
                setDebouncedValue(value);
                callback(value);
            }, delay);

            // Cleanup when component will unmount
            return () => {
                clearTimeout(handler);
            };
        },
        [value],
    );

    return debouncedValue;
};

export { useDebounce as default };
